/* PostHog events for the storefront. Capture starts only after analytics consent. */
(() => {
  const ph = () => window.posthog;

  const track = (event, properties) => {
    const client = ph();
    if (!client || client.has_opted_out_capturing?.()) return;
    client.capture(event, properties);
  };

  window.HP = window.HP || {};
  window.HP.track = track;

  /* The checkout custom pixel reads these hidden cart attributes to attach checkout events to the same visitor. */
  const stampCart = (tries = 0) => {
    const client = ph();
    if (!client || client.has_opted_out_capturing?.()) return;
    if (!client.__loaded) {
      if (tries < 20) setTimeout(() => stampCart(tries + 1), 250);
      return;
    }
    const attributes = { _ph_id: client.get_distinct_id(), _ph_session: client.get_session_id?.() || '' };
    fetch(`${window.Shopify?.routes?.root || '/'}cart/update.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes }),
      keepalive: true,
    }).catch(() => {});
  };

  let recording = false;

  const start = () => {
    const client = ph();
    if (!client || recording) return;
    recording = true;
    client.opt_in_capturing();
    client.capture('$pageview');
    const handle = location.pathname.match(/\/products\/([^/?#]+)/);
    if (handle) track('product_viewed', { handle: decodeURIComponent(handle[1]) });
    if (Number(document.querySelector('[data-hp-cart-count]')?.dataset.hpCartCount) > 0) stampCart();
  };

  const stop = () => {
    recording = false;
    ph()?.opt_out_capturing();
  };

  const sync = (allowed) => (allowed ? start() : stop());

  const readConsent = () => {
    const privacy = window.Shopify?.customerPrivacy;
    if (!privacy?.analyticsProcessingAllowed) return false;
    sync(privacy.analyticsProcessingAllowed() === true);
    document.addEventListener('visitorConsentCollected', (event) => {
      sync(Boolean(event.detail?.analyticsAllowed));
    });
    return true;
  };

  const boot = () => {
    if (readConsent()) return;
    window.Shopify?.loadFeatures?.([{ name: 'consent-tracking-api', version: '0.1' }], () => readConsent());
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  const seen = new Set();
  window.addEventListener(
    'scroll',
    () => {
      const max = document.documentElement.scrollHeight - window.innerHeight;
      if (max <= 0) return;
      const depth = Math.round((window.scrollY / max) * 100);
      for (const mark of [25, 50, 75, 90]) {
        if (depth >= mark && !seen.has(mark)) {
          seen.add(mark);
          track('scroll_depth', { depth: mark });
        }
      }
    },
    { passive: true }
  );

  const form = document.querySelector('[data-hp-form]');
  if (form) {
    const begin = (event) => {
      const node = event.target.closest?.('.hp-step, [data-hp-designs]') || event.target;
      const legend = node.querySelector?.('.hp-step__legend, .hp-label')?.innerText || '';
      track('configurator_started', { step: legend.replace(/\s+/g, ' ').trim().slice(0, 60) || 'configurateur' });
      form.removeEventListener('focusin', begin);
      form.removeEventListener('change', begin);
    };
    form.addEventListener('focusin', begin);
    form.addEventListener('change', begin);

    form.querySelector('[data-hp-name]')?.addEventListener(
      'input',
      (event) => {
        if (!event.target.value.trim()) return;
        track('configurator_name_entered');
      },
      { once: true }
    );
  }

  document.addEventListener('hp:cart-added', (event) => {
    const items = event.detail?.items || [];
    const cents = items.reduce((sum, item) => sum + (item.final_line_price || 0), 0);
    track('add_to_cart', { item_count: items.length, value: cents / 100 });
    stampCart();
  });

  document.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : null;
    if (!target) return;
    if (target.closest('button[name="checkout"]')) track('checkout_clicked');
    if (target.closest('a.action__cart, a[href$="/cart"]')) track('cart_opened');
    if (target.closest('[data-hp-express] shopify-accelerated-checkout, [data-hp-express] .shopify-payment-button')) {
      track('express_checkout_clicked');
    }
  });
})();
